module.exports = __webpack_public_path__ + "img/vi.b8575854.png";